interface ITiming {
  category: string;
  label: string;
  key: string;
  time: number;
}
type CustomTimingLogger = (timing: ITiming) => void;

class Logger {
  private customTimingLogger: CustomTimingLogger | null = null;

  public setCustomTimingLogger(customTimingLogger: CustomTimingLogger) {
    this.customTimingLogger = customTimingLogger;
  }

  public logCustomTiming(timing: ITiming) {
    if (this.customTimingLogger) {
      this.customTimingLogger(timing);
    }
  }
}
const logger = new Logger();

export const functionsToExpose = {
  setCustomTimingLogger: (timingLogger: CustomTimingLogger) => {
    logger.setCustomTimingLogger(timingLogger);
  },
};

export {logger as Logger};
